<template>
  <div
    v-show="visible"
    :class="className"
    @mousedown.prevent
    @click.stop="onOptionClick"
    @mouseenter="onOptionMouseEnter"
  >
    <slot>
      {{ label }}
    </slot>
  </div>
</template>

<script>
const name = 'ten-mention-option';

export default {
  name,
  inject: ['mention'],
  props: {
    /**
     * 选项的值，唯一
     */
    value: {
      type: [String, Number],
      required: true,
    },
    /**
     * 选项的显示值
     */
    label: {
      type: [String, Number],
      default() {
        return this.value;
      },
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    className() {
      return [
        'ten-mention-option',
        {
          'ten-mention-option--focused': this.mention.focusIndex === this.index,
          'ten-mention-option--visible': this.visible,
        },
      ];
    },
    optionObj() {
      return {
        _value: this.value,
        _label: String(this.label),
      };
    },
    visible() {
      if (this.mention.filterOption === false) return true;
      return this.mention.filterOption(this.mention.matchText, this.$props);
    },
  },
  watch: {
    'mention.options': {
      handler: 'updateIndex',
      deep: true,
    },
    'mention.matchText': {
      handler: 'updateIndex',
      immediate: true,
    },
    optionObj: {
      handler: 'updateOption',
    },
  },
  mounted() {
    this.updateOption();
  },
  beforeDestroy() {
    this.updateOption();
  },
  methods: {
    onOptionClick() {
      this.mention.$emit('option:click', this);
    },
    onOptionMouseEnter() {
      this.mention.$emit('option:focus', this);
    },
    updateOption() {
      if (!this.mention.dataSource) this.mention.$emit('option:update');
    },
    updateIndex() {
      this.$nextTick(() => {
        const visibleOptions = this.mention.getVisibleOptions();
        this.index = visibleOptions.findIndex(c => c === this.$el);
      });
    },
  },
};
</script>
